module.exports = __webpack_public_path__ + "static/media/s5-1.36428ba4.png";